import React from 'react';
import { FormattedNumber } from 'react-intl';

import { DEFAULT_CURRENCY } from 'constants/currency';

type Props = Omit<React.ComponentProps<typeof FormattedNumber>, 'value'> & {
  value: number | null | undefined;
};

export default function FormattedPrice({ value, currency = DEFAULT_CURRENCY, ...rest }: Props) {
  return value != null ? (
    <FormattedNumber
      style="currency"
      currency={currency}
      currencyDisplay="narrowSymbol"
      minimumFractionDigits={0}
      maximumFractionDigits={0}
      value={value}
      {...rest}
    />
  ) : (
    <>-</>
  );
}
